
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-optout",
      function () {
        return require("private-next-pages/ai-optout.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-optout"])
      });
    }
  